/* @flow */

import {combineReducers} from 'redux';

import {ActionTypes, type TinyIntroAction} from './tiny-intro-actions';
import type {SignupStartPage} from './types';

type EmailState = $PropertyType<TinyIntroState, 'userEmail'>;
export const userEmail = (state: EmailState = null, action: TinyIntroAction): EmailState => {
    switch (action.type) {
        case ActionTypes.TINY_INTRO_SET_EMAIL:
            return action.payload;
        default:
            return state;
    }
};

type SignupTokenState = $PropertyType<TinyIntroState, 'userSignupToken'>;
export const userSignupToken = (
    state: SignupTokenState = null,
    action: TinyIntroAction
): SignupTokenState => {
    switch (action.type) {
        case ActionTypes.TINY_INTRO_SET_SIGNUP_TOKEN:
            return action.payload;
        default:
            return state;
    }
};

type SignupStartPageState = $PropertyType<TinyIntroState, 'signupStartPage'>;
export const signupStartPage = (
    state: SignupStartPageState = null,
    action: TinyIntroAction
): SignupStartPageState => {
    switch (action.type) {
        case ActionTypes.TINY_INTRO_SET_SIGNUP_START_PAGE:
            return action.payload;
        default:
            return state;
    }
};

type AccountProvisionedState = {
    status: boolean,
    instanceId: ?string,
    emailSha1: ?string,
};

export const userAccountProvisionResponse = (
    state: AccountProvisionedState = {
        status: false,
        instanceId: null,
        emailSha1: null,
    },
    action: TinyIntroAction
): AccountProvisionedState => {
    switch (action.type) {
        case ActionTypes.TINY_INTRO_SET_PROVISION_RESPONSE:
            return action.payload;
        default:
            return state;
    }
};

type AccountProvisionedErrorMessage = $PropertyType<
    TinyIntroState,
    'userAccountProvisionedErrorMessage',
>;
export const userAccountProvisionedErrorMessage = (
    state: AccountProvisionedErrorMessage = null,
    action: TinyIntroAction
): AccountProvisionedErrorMessage => {
    switch (action.type) {
        case ActionTypes.TINY_INTRO_SET_PROVISION_ERROR_MESSAGE:
            return action.payload;
        default:
            return state;
    }
};

export type TinyIntroState = {
    userEmail: ?string,
    userSignupToken: ?string,
    signupStartPage: SignupStartPage,
    userAccountProvisionResponse: AccountProvisionedState,
    userAccountProvisionedErrorMessage: ?string,
};

// $FlowFixMe upgrading Flow to v0.92.1 on web
export const tinyIntroReducer = combineReducers({
    userEmail,
    userSignupToken,
    signupStartPage,
    userAccountProvisionResponse,
    userAccountProvisionedErrorMessage,
});
